module.exports = __webpack_public_path__ + "img/jt.48b06bda.png";